import React from 'react';
import moment from 'moment';
import sanitizeHtml from 'sanitize-html';
import { UsernameRegex, EmailRegex, DigitRegex } from './regex';

import 'moment-timezone';
export const setCookie = (cname, cvalue, exdays) => {
	var d = new Date();
	d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
	var expires = 'expires=' + d.toUTCString();
	document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
};

export const getCookie = (cname) => {
	var name = cname + '=';
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) === ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}
	return '';
};

export const getParameterByName = (name, url = '') => {
	if (!url) url = window.location.href;
	var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
		results = regex.exec(url);
	if (!results) return '';
	if (!results[2]) return '';
	return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export const getFullname = () => {
	var UserData = localStorage.getItem('userDetails');
	var User = JSON.parse(UserData);
	var FullName = User.full_name;
	if (FullName !== '') {
		return FullName;
	} else {
		return localStorage.getItem('loginId');
	}
};

export const getCourseId = () => {
	const activeCourseId = getParameterByName('course_id');
	if (activeCourseId !== null && activeCourseId !== '')
		localStorage.setItem('active_course_id', activeCourseId);
	return localStorage.getItem('active_course_id');
};

export const validateEmail = (email) => EmailRegex.test(email);

export const validateNumber = (text) => DigitRegex.test(text);

export const validUserName = (name) => UsernameRegex.test(name);

export const trimText = (text) => {
	if (!!text) {
		return text.replace(/\s/g, '');
	} else {
		return '';
	}
};

export const validateMobile = (contact) => {
	if (
		!validateNumber(contact) ||
		contact?.toString()?.length !== 10 ||
		contact?.toString()?.charAt(0) < 6
	) {
		return 'Please enter a valid mobile number';
	}
	return '';
};

export const isValidLoginId = (loginId) => {
	let isNumber = validateNumber(loginId);
	let isEmail = validateEmail(loginId);
	let panelMsg = '';
	loginId = trimText(loginId);
	if (loginId === '') {
		panelMsg = 'Please enter a valid email or mobile number';
	} else if (isNumber) {
		if (loginId.length === 10 || loginId.length === 12 || loginId.length === 16) {
			if (loginId.length === 12) {
				//&& !this.aadhaar.validateAadharNumber(loginId)) {
				panelMsg = 'Please enter valid aadhaar number';
			} else if (
				loginId.length === 10 &&
				loginId.charAt(0) < 6 &&
				loginId.charAt(0) !== '1'
			) {
				panelMsg = 'Please enter a valid mobile number';
			}
		} else {
			panelMsg = 'Please enter a 10-digit mobile number or Olympiad ID';
		}
	} else if (!isEmail) {
		panelMsg = 'Please enter a valid email';
	}
	return panelMsg;
};

export const getLoginType = (text, socialDomain) => {
	let login_type = '';
	if (validateEmail(text)) {
		login_type = !!socialDomain ? socialDomain : 'email';
	} else if (validateNumber(text)) {
		if (text.length === 10) {
			login_type = 'phone';
		} else if (text.length === 12) {
			login_type = 'aadhar_num';
		} else {
			login_type = 'stepathon_id';
		}
	} else if (validUserName(text)) {
		login_type = 'username';
	}
	return login_type;
};

export const clearLocalStorage = () => {
	let login_id = localStorage.getItem('login_id');
	localStorage.clear();
	if (login_id !== null) localStorage.setItem('login_id', login_id);
};

export const conditionallyClearStorage = (keysToExclude) => {
	if (keysToExclude !== null) {
		let values = [];
		keysToExclude.forEach((key) => {
			values.push(localStorage.getItem(key));
		});
		localStorage.clear();
		keysToExclude.forEach((key, i) => {
			localStorage.setItem(key, values[i]);
		});
		console.log('cleared storage');
	}
};

export const dateDiff = (timeLine, from, to = moment()) => {
	return moment(new Date(from)).diff(moment(new Date(to)), timeLine);
};

export const getResheduleURL = (event_id) => {
	return `Calendly.initPopupWidget({url:"https://calendly.com/reschedulings/${event_id}"});return false;`;
};

export const getCancelURL = (event_id) => {
	return `Calendly.initPopupWidget({url:"https://calendly.com/cancellations/${event_id}"});return false;`;
};
export const getTaskLink = (url, task) => {
	return `<span class="divAsAnchor" id="cancelCallLink" data-target="#cancelCall" data-toggle="modal" onclick='${url}'>${task} </span>`;
};

export const formatDate = (date, format) => {
	return moment(new Date(date)).format(format);
};

export const formatDateNew = (date, format) => {
	return moment(date, 'YYYY-MM-DD').format('D MMMM yyyy');
};

export const formatDateTime = (date, format) => {
	return moment(date, 'YYYY-MM-DD hh:mm A').format('hh:mm A');
};

export const toHHMMSS = (secondsTime) => {
	var sec_num = parseInt(secondsTime, 10); // don't forget the second param
	var minutes = Math.floor(sec_num / 60);
	var seconds = sec_num - minutes * 60;

	if (minutes < 10) {
		minutes = '0' + minutes;
	}
	if (seconds < 10) {
		seconds = '0' + seconds;
	}
	return minutes + ':' + seconds;
};

export const getStateOptions = () => {
	let states = [
		'Andaman and Nicobar Islands',
		'Andhra Pradesh',
		'Arunachal Pradesh',
		'Assam',
		'Bihar',
		'Chandigarh',
		'Chhattisgarh',
		'Dadra and Nagar Haveli',
		'Daman and Diu',
		'National Capital Territory of Delhi',
		'Goa',
		'Gujarat',
		'Haryana',
		'Himachal Pradesh',
		'Jammu and Kashmir',
		'Jharkhand',
		'Karnataka',
		'Kerala',
		'Lakshadweep',
		'Madhya Pradesh',
		'Maharashtra',
		'Manipur',
		'Meghalaya',
		'Mizoram',
		'Nagaland',
		'Odisha',
		'Puducherry',
		'Punjab',
		'Rajasthan',
		'Sikkim',
		'Tamil Nadu',
		'Telangana',
		'Tripura',
		'Uttar Pradesh',
		'Uttarakhand',
		'West Bengal',
	];
	let stateOptions = [];
	states.forEach(function (StateValue, index) {
		var isStateSelected = {};
		stateOptions.push(
			<option {...isStateSelected} value={StateValue} key={index}>
				{StateValue}
			</option>,
		);
	});
	return stateOptions;
};

export const onLoginEnter = (event) => {
	if (event.keyCode === 13) {
		event.preventDefault();
		document.getElementById('loginBtn').click();
	}
};

export const htmlDecode = (input) => {
	if (!!input) {
		input.replace(/(?:\r\n|\r|\n)/g, '<br />');
	}

	return sanitizeHtml(input, {
		allowedTags: ['b', 'i', 'em', 'strong', 'a', 'u', 'br'],
		allowedAttributes: {
			a: ['href'],
		},
	});
};

export const htmlEncode = (input) => {
	return encodeURIComponent(input);
};

export const stopAllAudio = () => {

	console.log('recording start');
	var audios = document.getElementsByTagName('audio');
	for (var i = 0, len = audios.length; i < len; i++) {
		audios[i].pause();
		audios[i].classList.add('disableAudio');
	}

};

export const enableAudio = () => {
	var audios = document.getElementsByTagName('audio');
	console.log('audio stop');
	for (var i = 0, len = audios.length; i < len; i++) {
		audios[i].classList.remove('disableAudio');
	}
	var arrow = document.querySelector('.arrow');
	if (arrow) {
		arrow.style.display = 'none';
	}

	var reload = document.querySelector('.reload');
	if (reload) {
		reload.style.display = 'block';

	}

};

export const recordAudio = () =>
	new Promise(async (resolve) => {
		const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
		const mediaRecorder = new MediaRecorder(stream);
		const audioChunks = [];

		mediaRecorder.addEventListener('dataavailable', (event) => {
			audioChunks.push(event.data);
		});

		const getStream = () => { return stream }

		const start = () => mediaRecorder.start();

		const stop = () =>
			new Promise((resolve) => {
				mediaRecorder.addEventListener('stop', () => {
					const audioBlob = new Blob(audioChunks);
					const audioUrl = URL.createObjectURL(audioBlob);
					const audio = new Audio(audioUrl);
					const play = () => audio.play();
					const pause = () => audio.pause();
					resolve({ audioBlob, audioUrl, play, pause });
				});

				mediaRecorder.stop();
			});

		resolve({ start, stop, getStream });
	});

export const sleep = (time) =>
	new Promise((resolve) => setTimeout(resolve, time));

export const isInStandaloneMode = () =>
	'standalone' in window.navigator && window.navigator.standalone;

export const isIos = () => {
	const userAgent = window.navigator.userAgent.toLowerCase();
	return (
		/iphone|ipad|ipod/.test(userAgent) ||
		navigator.platform.toLowerCase().indexOf('mac') >= 0
	);
};

export const getPrettyCallSchedule = (date) => {
	let [startTime, endTime] = date?.split('to');
	return {
		startTime,
		endTime,
	};
};

export const getCoachCallTime = (date) => {
	let { startTime, endTime } = getPrettyCallSchedule(date);
	return `${formatDate(startTime, 'DD-MM-yyyy')}, ${formatDate(
		startTime,
		'hh:mm A',
	)} to ${formatDate(endTime, 'hh:mm A')}`;
};

export const daysBeforeCall = (date) => {
	let { startTime } = getPrettyCallSchedule(date);

	return dateDiff('milliseconds', startTime);
};

export const minToMs = (min) => {
	return min * 60000;
};
export const getSupportPhone = (supportPhone) => {
	return `<span>This product is not available for you. Please call/message us at 
	${!!supportPhone && supportPhone.includes(',')
			? supportPhone
				.split(',')
				.map((phone, i) => {
					return `
							   <a
								   href="https://web.whatsapp.com/send?phone=${phone}&text=Hello%2C%20I%27m%20Interested%20in%20buying%20this%20course"
								   rel="noopener noreferrer"
								   target="_blank"
							   >
								   ${phone}													
							   </a>
							  ${i < supportPhone.split(',').length - 2
							? ','
							: i < supportPhone.split(',').length - 1
								? ' or'
								: ' '
						}
						   `;
				})
				.join('')
			: `<a href="https://web.whatsapp.com/send?phone=+91${supportPhone || 9789883344
			}&text=Hello%2C%20I%27m%20Interested%20in%20buying%20this%20course" rel="noopener noreferrer" target="_blank">+91-${supportPhone || 9789883344
			}</a> `
		} for more details.</span>`;
};

export const getLocalTime = (date) => {
	let revealDate = moment.tz(date, 'Asia/Calcutta');

	return revealDate.clone().tz(moment.tz.guess()).format();
};

export const setRevealTimer = (
	dateReveal,
	timeReveal,
	callBack = null,
	arg = null,
) => {
	let revealDate = `${dateReveal} ${timeReveal}`;
	if (moment.tz.guess() !== 'Asia/Calcutta') {
		revealDate = getLocalTime(revealDate);
		timeReveal = moment(revealDate).format('HH:mm:ss');
		dateReveal = moment(revealDate).format('DD-MM-YYYY');
	}

	let reveal = dateDiff('milliseconds', revealDate);

	if (!!dateReveal && !!timeReveal) {
		if (
			dateDiff('milliseconds', revealDate) > minToMs(0) &&
			dateDiff('milliseconds', revealDate) < minToMs(60)
		) {
			let timer = setInterval(function () {
				if (dateDiff('milliseconds', revealDate) <= minToMs(0)) {
					clearInterval(timer);
					if (!!callBack) {
						callBack(arg);
					} else {
						window.location.reload();
					}
				}
			}, 10000);
		}
	}
	return { revealDate, dateReveal, timeReveal, reveal };
};
